import { useState, useEffect } from "react";
import {
  Ban,
  Phone,
  AlertCircle,
  Trash2,
  Calendar,
  ChevronDown,
  RefreshCw,
} from "lucide-react";

export default function BlockedNumbers() {
  const [blockedNumbers, setBlockedNumbers] = useState([]);
  const [phone, setPhone] = useState("");
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");

  // Add new blocked number
const handleAddBlocked = async () => {
  if (!phone || !reason) {
    alert("Please enter a phone number and select a reason ⚠️");
    return;
  }

  // تحقق إذا الرقم موجود مسبقاً
  const exists = blockedNumbers.some(
    (item) => item.number === phone
  );
  if (exists) {
    alert("This phone number is already blocked ⚠️");
    return; // يمنع استدعاء API
  }

  const token = localStorage.getItem("token");

  const res = await fetch("https://zaichat.net/api/save_blocked_number", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      auth: `Bearer ${token}`,
    },
    body: JSON.stringify({ number: phone, reason, notes }),
  }).then((res) => res.json());

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    return;
  }

  if (res.status === "400") {
    alert(res.message);
    return;
  }

  console.log(blockedNumbers)

  setBlockedNumbers([...blockedNumbers, res.data]);
  setPhone("");
  setReason("");
  setNotes("");
};



  // Fetch all blocked numbers
  useEffect(() => {
    const fetchdata = async () => {
      const token = localStorage.getItem("token");

      const res = await fetch("https://zaichat.net/api/blocked_number", {
        headers: {
          auth: `Bearer ${token}`,
        },
      });

      if (res.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }

      const data = await res.json();
      setBlockedNumbers(data.data);
    };

    fetchdata();
  }, []);

  // Delete blocked number
  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");

    const res = await fetch("https://zaichat.net/api/blocked_number", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        auth: `Bearer ${token}`,
      },
      body: JSON.stringify({ id }),
    }).then((res) => res.json());

    if (res.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return;
    }

    // Update UI after delete
    setBlockedNumbers(blockedNumbers.filter((n) => n.id !== id));
  };

  return (
    <div className="min-h-screen bg-cream text-primary py-10 px-6 md:px-10">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary to-accent text-white rounded-2xl p-8 shadow-lg mb-8">
        <h1 className="text-3xl font-extrabold mb-2 flex items-center gap-2">
          <Ban size={30} className="text-white" />
          Blocked Numbers Management
        </h1>
        <p className="text-white/90 text-sm">
          Manage and monitor numbers blocked from communicating with your bot.
        </p>
      </div>

      {/* Main Form */}
      <div className="bg-white rounded-2xl shadow-md border-t-4 border-accent p-8 mb-8">
        <div className="flex justify-center mb-6">
   
        </div>

        {/* Add Blocked Number */}
        <div className="border border-accent/30 rounded-xl p-6">
          <div className="flex items-center gap-2 mb-6">
            <Ban className="text-accent w-6 h-6" />
            <h2 className="text-xl font-bold text-primary">Add Blocked Number</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-6">
            {/* Phone field */}
            <div>
              <label className="block text-sm font-semibold text-dark/80 mb-2">
                Phone Number
              </label>
              <div className="flex items-center border border-primary/30 rounded-lg px-3 py-2">
                <Phone size={18} className="text-accent mr-2" />
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="966501234567"
                  className="w-full text-sm bg-transparent focus:outline-none"
                />
              </div>
            </div>

            {/* Reason */}
            <div>
              <label className="block text-sm font-semibold text-dark/80 mb-2">
                Block Reason *
              </label>
              <div className="relative">
                <select
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none"
                >
                  <option value="">Select a reason</option>
                  <option>Repeated spam messages</option>
                  <option>Inappropriate requests</option>
                  <option>Unwanted advertising</option>
                  <option>Other reason</option>
                </select>
                <ChevronDown
                  size={18}
                  className="absolute right-3 top-3.5 text-dark/40"
                />
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="mb-6">
            <label className="block text-sm font-semibold text-dark/80 mb-2">
              Notes
            </label>
            <textarea
              rows="3"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className="w-full border border-primary/30 rounded-lg p-3 text-sm focus:outline-none"
              placeholder="Add notes..."
            />
          </div>

          <div className="text-end">
            <button
              onClick={handleAddBlocked}
              className="flex items-center gap-2 bg-accent text-white px-6 py-2 rounded-lg font-semibold hover:bg-accent/90 transition mx-auto md:mx-0"
            >
              <Ban size={16} />
              Block Number
            </button>
          </div>
        </div>
      </div>

      {/* Blocked Numbers List */}
      <div className="bg-white rounded-2xl shadow-md border-t-4 border-primary p-8">
        <div className="flex items-center gap-2 mb-5">
          <AlertCircle className="text-primary w-6 h-6" />
          <h2 className="text-xl font-bold text-primary">
            Blocked Numbers List
          </h2>
        </div>

        {blockedNumbers.length === 0 ? (
          <p className="text-dark/60 text-sm">No blocked numbers yet.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse mt-4 text-sm">
              <thead>
                <tr className="bg-cream text-primary font-semibold text-center">
                  <th className="border border-primary/20 p-3">Phone Number</th>
                  <th className="border border-primary/20 p-3">Reason</th>
                  <th className="border border-primary/20 p-3">Notes</th>
                  <th className="border border-primary/20 p-3">Date Added</th>
                  <th className="border border-primary/20 p-3">Action</th>
                </tr>
              </thead>
              <tbody>
                {blockedNumbers.map((item, index) => (
                  <tr
                    key={index}
                    className="text-center hover:bg-cream/60 transition"
                  >
                    <td className="border border-primary/20 p-3">{item.number}</td>
                    <td className="border border-primary/20 p-3">{item.reason}</td>
                    <td className="border border-primary/20 p-3">
                      {item.notes || "—"}
                    </td>
                    <td className="border border-primary/20 p-3 flex items-center justify-center gap-1">
                      <Calendar size={14} className="text-accent" />{" "}
                      {item.created_at}
                    </td>
                    <td className="border border-primary/20 p-3">
                      <button
                        onClick={() => handleDelete(item.id)}
                        className="flex items-center gap-1 text-red-600 hover:text-red-800 transition mx-auto"
                      >
                        <Trash2 size={16} />
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
